// 对axios进行二次封装
import axios from "axios";
import { handleError, responseInterceptor, requestInterceptor } from "./interceptor";

let baseURL = process.env.NODE_ENV == "development" ? "/" : process.env.VUE_APP_BASE_API;
const instance = axios.create({
  baseURL,
  timeout: 0,
  headers: {
    ...(process.env.NODE_ENV == 'development' ? {app: 'yl_business'} : {})
  }
});
instance.interceptors.request.use(requestInterceptor);
instance.interceptors.response.use(responseInterceptor, handleError);
export default instance;
